export default "__VITE_ASSET__C3VWS9K6__"